import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAppId } from '../../context/AppIdContext';
import Header from '../../component/header';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const GroupWiseBeneficiary = () => {
    const { appId, language } = useAppId();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const lang = language || 'en';

    const t = {
        en: {
            title: "Group Wise Beneficiary",
            searchPlaceholder: "Search by Group Name...",
            loading: "Loading Data...",
            totalVoter: "Total Voter",
            match: "Match",
            remaining: "Remaining",
            noData: "No records found matching",
            group: "Group"
        },
        hi: {
            title: "ग्रुप अनुसार लाभार्थी",
            searchPlaceholder: "ग्रुप नाम से खोजें...",
            loading: "डेटा लोड हो रहा है...",
            totalVoter: "कुल मतदाता",
            match: "मैच",
            remaining: "बाकी",
            noData: "कोई रिकॉर्ड नहीं मिला",
            group: "ग्रुप"
        },
        gu: {
            title: "ગ્રુપ પ્રમાણે લાભાર્થી",
            searchPlaceholder: "ગ્રુપ નામથી શોધો...",
            loading: "ડેટા લોડ થઈ રહ્યો છે...",
            totalVoter: "કુલ મતદાર",
            match: "મેચ",
            remaining: "બાકી",
            noData: "કોઈ રેકોર્ડ મળ્યો નથી",
            group: "ગ્રુપ"
        }
    };

    const txt = t[lang] || t.en;

    useEffect(() => {
        if (appId) {
            fetchData();
        }
    }, [appId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/dis_my_group_wise_beneficiary_dash`, {
                app_id: appId
            });

            if (response.data.success && response.data.data && response.data.data.result && response.data.data.result.Table) {
                setData(response.data.data.result.Table);
            } else if (response.data.success && response.data.data && Array.isArray(response.data.data.result)) {
                setData(response.data.data.result);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching group beneficiary data:", error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const filteredData = data.filter(item => {
        if (!searchTerm) return true;
        const lowerSearch = searchTerm.toLowerCase();
        const groupName = item.group_name || item.name || '';
        return (
            groupName.toLowerCase().includes(lowerSearch) ||
            (item.mobile_no && item.mobile_no.includes(lowerSearch))
        );
    });

    return (
        <div className="phonebook-ben-page">
            <div className="header-wrapper">
                <Header title={txt.title} />
            </div>

            <div className="content-container container-fluid p-3 p-md-4">

                <div className="search-container slide-up-element">
                    <div className="search-wrapper">
                        <svg className="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            type="text"
                            className="search-input"
                            placeholder={txt.searchPlaceholder}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>

                {loading ? (
                    <div className="loader-wrapper">
                        <div className="spinner"></div>
                        <p className="loader-text">{txt.loading}</p>
                    </div>
                ) : (
                    <div className="beneficiary-grid slide-up-element" style={{ animationDelay: '0.1s' }}>
                        {filteredData.length > 0 ? (
                            filteredData.map((item, index) => {
                                const total = Number(item.total_voter || 0);
                                const matched = Number(item.total_beneficiaries || item.total_beneficiary || 0);
                                const remaining = total - matched;
                                const displayName = item.group_name || item.name || txt.group;

                                return (
                                    <div
                                        key={item.group_id || item.user_id || index}
                                        className="ben-card"
                                        onClick={() => navigate('/dis_my_group_wise_beneficiary_voter', {
                                            state: {
                                                user_id: item.user_id,
                                                userName: item.name || item.group_name,
                                                name: item.name || item.group_name
                                            }
                                        })}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="ben-card-header">
                                            <div className="ben-avatar-box">
                                                {item.photo_path ? (
                                                    <img src={item.photo_path} alt={displayName} className="ben-avatar-img" />
                                                ) : (
                                                    <svg className="ben-avatar-placeholder" viewBox="0 0 24 24" fill="currentColor">
                                                        <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                                                    </svg>
                                                )}
                                            </div>

                                            <div className="ben-info">
                                                <h3 className="ben-name">{index + 1}. {displayName}</h3>
                                                <p className="ben-designation">{item.designation || item.create_by_name || txt.group}</p>
                                            </div>

                                            {item.mobile_no ? (
                                                <a href={`tel:${item.mobile_no}`} className="ben-call-btn" title="Call" onClick={(e) => e.stopPropagation()}>
                                                    <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
                                                        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                                                    </svg>
                                                </a>
                                            ) : null}
                                        </div>

                                        <div className="ben-stats-row">
                                            <div className="ben-stat-box stat-total">
                                                <div className="stat-num">{total}</div>
                                                <div className="stat-label">{txt.totalVoter}</div>
                                            </div>
                                            <div className="ben-stat-box stat-match">
                                                <div className="stat-num">{matched}</div>
                                                <div className="stat-label">{txt.match}</div>
                                            </div>
                                            <div className="ben-stat-box stat-pending">
                                                <div className="stat-num">{remaining}</div>
                                                <div className="stat-label">{txt.remaining}</div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="no-data-wrapper">
                                <div style={{ fontSize: '40px', marginBottom: '10px' }}>📭</div>
                                <h4>{searchTerm ? `${txt.noData} "${searchTerm}"` : txt.noData}</h4>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <style jsx>{`
                .phonebook-ben-page {
                    width: 100%;
                    min-height: 100vh;
                    background: #E5E7EB;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
                    padding-bottom: 40px;
                }

                .header-wrapper {
                    background: white;
                    padding: 0 24px;
                    position: sticky;
                    top: 0;
                    z-index: 50;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
                    width: 100%;
                }
                .header-wrapper :global(.header-container-white) {
                    margin: 0;
                    padding: 12px 0;
                    position: static;
                    box-shadow: none;
                    border-bottom: none;
                    width: 100%;
                }

                .content-container {
                    width: 100%;
                    max-width: none;
                }

                .search-container {
                    margin-bottom: 24px;
                    display: flex;
                    justify-content: flex-end;
                }
                .search-wrapper {
                    position: relative;
                    width: 100%;
                    max-width: 400px;
                }
                .search-icon {
                    position: absolute;
                    left: 14px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    width: 20px;
                    height: 20px;
                }
                .search-input {
                    width: 100%;
                    padding: 12px 16px 12px 42px;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    font-size: 14px;
                    color: #1e293b;
                    outline: none;
                    transition: all 0.2s ease;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                    background: #ffffff;
                }
                .search-input:focus {
                    border-color: #3b82f6;
                    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
                }

                .beneficiary-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 20px;
                }

                .ben-card {
                    background: #ffffff;
                    border-radius: 14px;
                    border: 1px solid #e2e8f0;
                    padding: 16px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                }
                .ben-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
                }

                .ben-card-header {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                }

                .ben-avatar-box {
                    width: 54px;
                    height: 54px;
                    border-radius: 50%;
                    background: #f1f5f9;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    flex-shrink: 0;
                    border: 1px solid #e2e8f0;
                }
                .ben-avatar-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .ben-avatar-placeholder {
                    width: 30px;
                    height: 30px;
                    color: #cbd5e1;
                }

                .ben-info {
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                    flex: 1;
                    overflow: hidden;
                }
                .ben-name {
                    font-size: 16px;
                    font-weight: 800;
                    color: #1e1b4b;
                    margin: 0;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .ben-designation {
                    font-size: 13.5px;
                    font-weight: 500;
                    color: #64748b;
                    margin: 0;
                }

                .ben-call-btn {
                    width: 44px;
                    height: 44px;
                    border-radius: 50%;
                    background: #e0f2fe;
                    color: #0284c7;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    text-decoration: none;
                    transition: background 0.2s ease;
                }
                .ben-call-btn:hover {
                    background: #bae6fd;
                }

                .ben-stats-row {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 10px;
                }

                .ben-stat-box {
                    border-radius: 8px;
                    padding: 10px 4px;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    gap: 2px;
                }

                .stat-num {
                    font-size: 18px;
                    font-weight: 800;
                    line-height: 1.2;
                }
                .stat-label {
                    font-size: 11px;
                    font-weight: 700;
                }

                .stat-total {
                    background: #f1f5f9;
                }
                .stat-total .stat-num, .stat-total .stat-label {
                    color: #1e1b4b;
                }

                .stat-match {
                    background: #ecfdf5;
                }
                .stat-match .stat-num, .stat-match .stat-label {
                    color: #166534;
                }

                .stat-pending {
                    background: #fef2f2;
                }
                .stat-pending .stat-num, .stat-pending .stat-label {
                    color: #991b1b;
                }

                .no-data-wrapper {
                    grid-column: 1 / -1;
                    background: white;
                    padding: 40px 20px;
                    border-radius: 12px;
                    text-align: center;
                    color: #64748b;
                    border: 1px solid #e2e8f0;
                }
                .loader-wrapper {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    min-height: 50vh;
                }
                .spinner {
                    width: 44px;
                    height: 44px;
                    border: 3px solid #e2e8f0;
                    border-top: 3px solid #3b82f6;
                    border-radius: 50%;
                    animation: spin 0.8s linear infinite;
                    margin-bottom: 16px;
                }
                .loader-text {
                    color: #64748b;
                    font-weight: 600;
                }
                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

                .slide-up-element {
                    animation: slideUp 0.4s ease forwards;
                    opacity: 0;
                }
                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(15px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                @media (max-width: 1200px) {
                    .beneficiary-grid {
                        grid-template-columns: repeat(3, 1fr);
                    }
                }
                @media (max-width: 992px) {
                    .beneficiary-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }
                }
                @media (max-width: 640px) {
                    .beneficiary-grid {
                        grid-template-columns: 1fr;
                    }
                    .search-container {
                        justify-content: stretch;
                    }
                    .search-wrapper {
                        max-width: 100%;
                    }
                }
            `}</style>
        </div>
    );
};

export default GroupWiseBeneficiary;
